import React from 'react';
import RequireRootRole from './components/RequireRootRole';
import PromptPipelineSettings, {
  missingRequirements as genericMissingRequirements,
  toForm as genericToForm,
  toPayload as genericToPayload
} from './components/PromptPipelineSettings';
import AnalysisConfigService from '../../../../services/AnalysisConfigService';

// Mismas reglas que analysis_config.py (backend): aquí solo para avisar
// antes de guardar; el backend vuelve a validar y responde 400.
export const STAGES = [
  {
    key: 'planner',
    label: '1. Planificador',
    description: 'Convierte la pregunta en un plan de hipótesis y pasos. Es una llamada al modelo, sin consultar los datos.',
    placeholders: [
      ['<<question>>', 'pregunta del usuario'],
      ['<<schema_context>>', 'tablas, columnas y relaciones del modelo semántico'],
      ['<<conversation_context>>', 'turnos previos de la conversación (opcional)'],
      ['<<max_steps>>', 'límite de pasos']
    ],
    required: ['<<question>>', '<<schema_context>>', '<<max_steps>>', '<plan>', '</plan>']
  },
  {
    key: 'investigator',
    label: '2. Investigador',
    description: 'Se añade a la instrucción del agente del workspace y ejecuta el plan con sus herramientas de consulta, con un hallazgo por paso.',
    placeholders: [
      ['<<plan>>', 'plan generado por el planificador'],
      ['<<schema_context>>', 'tablas y columnas del modelo semántico (opcional: si falta, se añade al final)'],
      ['<<max_queries>>', 'límite de consultas'],
      ['<<queries_per_step>>', 'consultas por paso: límite entre pasos del plan (opcional)']
    ],
    required: ['<<plan>>', '<<max_queries>>', '<finding step=', '</finding>']
  },
  {
    key: 'synthesizer',
    label: '3. Sintetizador',
    description: 'Recibe el plan y los hallazgos, verifica que las cifras sean coherentes y redacta el informe final.',
    placeholders: [
      ['<<question>>', 'pregunta del usuario'],
      ['<<plan>>', 'plan generado por el planificador'],
      ['<<findings>>', 'hallazgos del investigador con sus resultados']
    ],
    required: ['<<question>>', '<<plan>>', '<<findings>>', '<report>', '</report>']
  }
];

export const LIMITS = [
  { key: 'max_steps', label: 'Pasos máximos del plan', min: 1, max: 12 },
  { key: 'max_queries', label: 'Consultas máximas', min: 1, max: 40 },
  { key: 'max_scanned_mb', label: 'Datos escaneados máximos (MB)', min: 1, max: 102400 },
  { key: 'time_budget_seconds', label: 'Tiempo máximo (segundos)', min: 60, max: 840 }
];

export const DEEP_ANALYSIS_DESCRIPTOR = {
  title: 'Análisis profundo',
  description: 'Prompts, modelos y límites del modo "Análisis Profundo" del chat. El análisis corre en tres etapas: planificar, investigar con consultas a los datos y redactar el informe. Los cambios aplican en el siguiente análisis, sin desplegar nada.',
  service: AnalysisConfigService,
  stages: STAGES,
  limits: LIMITS,
  options: [],
  limitsTitle: 'Límites del análisis',
  limitsSubtitle: 'Se aplican en el código, no dependen de que el modelo los respete. Al acercarse al tiempo máximo, el análisis se detiene y entrega un informe parcial con lo encontrado.',
  enabledLabel: 'Análisis Profundo habilitado',
  disabledLabel: 'Análisis Profundo deshabilitado para todos los usuarios',
  savedMessage: 'Configuración guardada. Aplica en el siguiente análisis.'
};

export const toForm = (config) => genericToForm(config, DEEP_ANALYSIS_DESCRIPTOR);
export const toPayload = (form) => genericToPayload(form, DEEP_ANALYSIS_DESCRIPTOR);
export const missingRequirements = (stageKey, prompt) => genericMissingRequirements(DEEP_ANALYSIS_DESCRIPTOR, stageKey, prompt);

const DeepAnalysisSettings = () => (
  <RequireRootRole title="Análisis profundo">
    <PromptPipelineSettings descriptor={DEEP_ANALYSIS_DESCRIPTOR} />
  </RequireRootRole>
);

export default DeepAnalysisSettings;
